import { FontFamily } from "@redotech/redo-model/brand-kit";
import { MarketingForgeElementType } from "@redotech/redo-model/content-builder/element-schema";
import {
  LoyaltyElementType,
  LoyaltyPageBlock,
} from "@redotech/redo-model/loyalty/loyalty-page-builder/definition";
import { BrandKitOverrides } from "@redotech/redo-model/signup-form-schema";
import { assertNever } from "@redotech/util/type";
import { memo } from "react";
import { FormImage } from "../../marketing/form-elements/form-image";
import { RichText } from "../../marketing/form-elements/rich-text";
import { EarningRules } from "./earning-rules";
import { Hero } from "./hero";
import { PointsSummary } from "./points-summary";
import { Promotions } from "./promotions";

// not used right now but will come in handy later
export const defaultBrandKitOverrides: BrandKitOverrides = {
  buttons: {
    enabled: false,
    primary: {
      font: {
        fontFamily: FontFamily.ARIAL,
        fontWeight: "regular",
        fontSizePx: 16,
      },
      textColor: "#000000",
      backgroundColor: "#ffffff",
      border: { cornerRadiusPx: 0, stroke: { color: "#000000", weightPx: 0 } },
      paddingPx: 0,
    },
    secondary: {
      font: {
        fontFamily: FontFamily.ARIAL,
        fontWeight: "regular",
        fontSizePx: 16,
      },
      textColor: "#000000",
      backgroundColor: "#ffffff",
      border: { cornerRadiusPx: 0, stroke: { color: "#000000", weightPx: 0 } },
      paddingPx: 0,
    },
    tertiary: {
      font: {
        fontFamily: FontFamily.ARIAL,
        fontWeight: "regular",
        fontSizePx: 16,
      },
      textColor: "#000000",
      backgroundColor: "#ffffff",
      border: { cornerRadiusPx: 0, stroke: { color: "#000000", weightPx: 0 } },
      paddingPx: 0,
    },
  },
  inputs: {
    enabled: false,
    font: {
      fontFamily: FontFamily.ARIAL,
      fontWeight: "regular",
      fontSizePx: 16,
    },
    textColor: "#000000",
    backgroundColor: "#ffffff",
    border: { cornerRadiusPx: 0, stroke: { color: "#000000", weightPx: 0 } },
    paddingPx: 0,
    errorColor: "#ff0000",
  },
};

export const BlockContent = memo(function BlockContent({
  block,
}: {
  block: LoyaltyPageBlock;
}) {
  if ("visible" in block && !block.visible) {
    return null;
  }
  switch (block.type) {
    case LoyaltyElementType.HERO:
      return <Hero {...block} />;

    case LoyaltyElementType.POINTS_SUMMARY:
      return <PointsSummary {...block} />;

    case LoyaltyElementType.PROMOTIONS:
      return <Promotions {...block} />;

    case LoyaltyElementType.EARNING_RULES:
      return <EarningRules {...block} />;

    case MarketingForgeElementType.RICH_TEXT:
      return <RichText element={block} />;

    case MarketingForgeElementType.IMAGE:
      return <FormImage element={block} />;

    default:
      assertNever(block);
  }
});
